import { useState, useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import useFetchWithMsal from "./useFetchWithMsal";
import { protectedResources } from "../authConfig";

const useBranches = () => {
  const { execute } = useFetchWithMsal({
    scopes: protectedResources.apiScopes.scopes.read,
  });

  const fetchAccountingFirms = async () => {
    try {
      const response = await execute(
        "GET",
        `${process.env.REACT_APP_BACKEND_BASE_URL}/api/accounting-firms`
      );

      if (!response || !response.accountingFirms) {
        throw new Error('Failed to fetch accounting firms');
      }
      
      return response.accountingFirms;
    } catch (error) {
      console.error('Error fetching accounting firms:', error);
      throw error;
    }
  };

  const {
    data: accountingFirms = [],
    isLoading,
    error,
    refetch
  } = useQuery({
    queryKey: ['accountingFirms'],
    queryFn: fetchAccountingFirms,
    refetchOnWindowFocus: false,
    refetchOnMount: "always",
    staleTime: 5 * 60 * 1000, 
    retry: 2
  });


  const companies = accountingFirms?.map(firm => ({
    id: firm._id,
    name: firm.companyName,
    companyNumber: firm.companyNumber, 
    accountant: firm.accountant,
    email: firm.email
  })) || [];

  const profitCenters = []; // TODO

  return {
    companies,
    profitCenters,
    isLoading,
    error,
    refetch
  };
};

export default useBranches;
